import locationHelperBuilder from "redux-auth-wrapper/history3/locationHelper";
import { connectedRouterRedirect } from "redux-auth-wrapper/history3/redirect";
import { routerActions } from "react-router-redux";

import Loading from "./molecules/components/Loading";

const locationHelper = locationHelperBuilder({});

export const userIsAuthenticated = connectedRouterRedirect({
  redirectPath: "/login",
  authenticatedSelector: state => state.common.token !== null,
  authenticatingSelector: state => state.common.isLoading,
  AuthenticatingComponent: Loading,
  redirectAction: routerActions.replace,
  wrapperDisplayName: "UserIsAuthenticated"
});

export const userIsAdmin = connectedRouterRedirect({
  redirectPath: "/",
  allowRedirectBack: false,
  authenticatedSelector: state =>
    state.common.token !== null && state.common.isAdmin,
  redirectAction: routerActions.replace,
  wrapperDisplayName: "UserIsAdmin"
});

export const userIsNotAuthenticated = connectedRouterRedirect({
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || "/",
  allowRedirectBack: false,
  // Want to redirect the user when they are done loading and authenticated
  authenticatedSelector: state => state.common.token === null,
  redirectAction: routerActions.replace,
  wrapperDisplayName: "UserIsNotAuthenticated"
});



// WEBPACK FOOTER //
// ./src/auth.js